// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"4ce97d91","703":"f64cd02c","787":"0cbe2c19"}[chunkId] + ".chunk.js";
};